<template>
    <CSidebar fixed
              :minimize="minimize"
              :show.sync="show">
        <!-- new custom menu bar -->
        <div @mouseover="hover = true" @mouseleave="hover = false">
            <ul class="c-scroll-area p-0 m-0 ps" style="position: relative;z-index: 5;">
                <li class='user-profile'>
                    <div class='user-detail'>
                        <div class='user-detail-row c-sidebar-nav-top'>
                            <i v-if="this.getUserInfo.AT == 0" class="fa fa-user-shield gg-ico gg-ico-ssa"></i>
                            <i v-if="this.getUserInfo.AT == 1" class="fa fa-user-alt gg-ico gg-ico-sa"></i>
                            <i v-if="this.getUserInfo.AT == 2" class="fa fa-user-friends gg-ico gg-ico-ma"></i>
                            <i v-if="this.getUserInfo.AT == 3" class="fa fa-users gg-ico gg-ico-a"></i>
                            <i v-if="this.getUserInfo.AT == 4 && !this.getUserInfo.IOL" class="fa fa-users gg-ico gg-ico-sag"></i>
                            <i v-if="this.getUserInfo.AT == 4 && this.getUserInfo.IOL" class="fa fa-users gg-ico gg-ico-outlet"></i>
                            <div class="menu-Name one text-white" :class="getUserInfo.RS == 3 ? 'freeze-user' : ''" >
                                <p>{{ this.getUserInfo.DN }} ({{ this.getUserInfo.PC }})</p>
                                <i class="cil-snowflake freeze" v-if="getUserInfo.RS == 3"></i>
                            </div>

                        </div>
                        <div class='user-detail-row c-sidebar-nav-top'>
                            <i class="fa fa-award text-white"></i>
                            <div class="menu-Name one text-white">
                                <p>{{ this.getUserInfo.RN }}</p>
                            </div>
                            <router-link :to="{ path: '/AGS/AGD', query: this.$route.path == '/AGS/AGD' ? { rst: 1 } : {} }" v-if="checkModuleAccess('ASS', 'AGS', constAccessType.view)">
                                <div class="custom-tooltip" style="padding-left:5px;">
                                    <div class="blobs-container">
                                        <div class="blob">
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet" style="font-size: 20px; width: 20px;">
                                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#a9adcc" stroke="none">
                                                    <path d="M2120 5109 c-427 -48 -851 -270 -1128 -589 -417 -481 -547 -1123 -351 -1724 38 -116 103 -254 137 -289 78 -82 226 -35 248 79 8 42 1 64 -56 194 -83 188 -128 432 -117 640 20 368 158 686 414 951 211 218 460 355 764 420 147 32 420 33 561 1 550 -121 982 -518 1134 -1040 45 -155 57 -259 51 -447 -6 -193 -29 -314 -91 -474 -40 -103 -44 -146 -20 -197 44 -93 191 -103 252 -17 26 37 85 198 111 303 72 292 68 610 -10 895 -112 406 -375 767 -737 1008 -340 227 -763 331 -1162 286z" />
                                                    <path d="M2155 4509 c-596 -87 -1037 -622 -1001 -1215 14 -235 103 -491 186 -536 99 -53 220 18 220 128 0 24 -12 68 -30 107 -58 129 -74 207 -74 362 1 110 5 156 22 218 82 299 320 537 621 619 112 31 316 31 424 0 277 -79 497 -275 601 -536 75 -188 76 -413 1 -611 -40 -107 -31 -163 35 -219 25 -20 42 -26 81 -26 95 0 131 36 178 177 48 142 64 256 58 418 -8 222 -63 398 -182 582 -71 108 -241 280 -345 348 -241 156 -527 223 -795 184z" />
                                                    <path d="M2239 3896 c-102 -27 -171 -87 -218 -186 l-26 -55 0 -1225 0 -1225 31 -85 c16 -47 47 -112 68 -143 53 -80 154 -169 240 -211 133 -66 129 -66 946 -66 818 0 814 0 950 66 106 52 223 170 274 276 62 129 66 163 66 624 0 385 -1 416 -20 477 -64 208 -321 294 -492 164 -54 -41 -105 -116 -120 -175 l-11 -46 -14 48 c-27 93 -93 169 -182 210 -66 30 -188 29 -256 -2 -87 -40 -158 -123 -181 -211 l-11 -46 -16 55 c-28 94 -99 171 -197 211 -45 18 -175 18 -220 0 -94 -39 -179 -130 -197 -211 -5 -19 -10 316 -13 745 -5 772 -5 780 -27 826 -44 94 -120 158 -220 184 -67 18 -92 18 -154 1z" />
                                                    <path d="M2410 261 c0 -148 1 -160 23 -192 48 -73 3 -69 859 -67 762 3 767 3 795 24 59 44 68 74 71 242 l4 153 -54 -8 c-67 -10 -1586 -11 -1650 -1 l-48 8 0 -159z" />
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="custom-tooltiptext2" style=" width: 145px; bottom: auto; top: 143%; height: 65px; left: 20%;"> {{getLanguage["AG"]["SSAWLCMSG"]}}</div>
                                </div>
                            </router-link>
                        </div>
                        <div class='user-detail-row c-sidebar-nav-top'>
                            <i class="fa-solid fa-dollar-sign text-white"></i>
                            <div class="menu-Name one text-white" @click="redirectToCreditHistory">
                                <p v-if='this.getBalanceStatus == 1'><a href="#">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</a></p>
                                <p v-if='this.getBalanceStatus == 2' class="warningbalance">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</p>
                                <p v-if='this.getBalanceStatus == 3' class="balanceflash">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</p>
                                <p v-if='this.getBalanceStatus == 4' class="balanceflash">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</p>
                            </div>
                        </div>

                        <div v-if='this.getUserInfo.AT == 4 && this.getUserInfo.IOL == 0 && this.getUserInfo.SARL != null && this.getUserInfo.SARL != ""' class='user-detail-row c-sidebar-nav-top'>
                            <i class="fas fa-external-link-alt"></i>
                            <div class="menu-Name one">
                                <p v-on:click="copyReferralLink()" class="pointer">{{this.getLanguage["MEM"]["RIURL"]}} <i class="fas fa-copy" style="display: inline-block; font-size: 1em; width: 12px; height: 12px; margin-right: auto; margin-left: 5px;"></i></p>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="c-sidebar-nav-dropdown activeLvl1" :class="[($parent.showSubMenu == 'FAV' || isFirstLoad ? 'c-show' : '')]" v-if="favMenuList!=null && favMenuList.length>0" style="font-size: 12px">
                    <a class="c-sidebar-nav-dropdown-toggle" v-on:click="changeShowSubMenu('FAV')">
                        <i class="fas fa-star" style="color: yellow;"></i>
                        <div class="menu-Name">
                            <span>{{ this.getLanguage["SMB"]["FAV"] }}</span>
                        </div>
                    </a>
                    <ul class="c-sidebar-nav-dropdown-items d-sm-down-none" :class="(isMinimize && minimize) ? 'd-none' :''" style="font-size: 12px; padding-left: 0px">
                        <li class="c-sidebar-nav-item" v-for="(data, index) in favMenuList" :class="{ 'menuActive' : $parent.showActiveMenu == data.PM + '.' + data.MN }" v-if="data.IHM == false">
                            <router-link :to="'/'+ data.PM + '/'+ data.MN" :target="(data.MN == 'CRMDU' || data.MN == 'LCHAT' || data.MN == 'VG' || data.MN == 'UM')?'_blank':'_self'">
                                <a id="subSubMenu" class="c-sidebar-nav-link" @click="addMenuToFavorite(data,checkModuleIndex(data.MN, data.PM, constAccessType.view),false,null,true)">
                                    <div class="dropdown-Name">
                                        <!--<span v-if="data.MID">{{ data.MID }}</span>
                                        <span v-else>{{ checkModuleIndex(data.MN, data.PM, constAccessType.view) }}</span>-->
                                        <span>{{ checkModuleIndex(data.MN, data.PM, constAccessType.view, '', (data.SPM ? -1 : 0)) }}</span>
                                        <span>{{ getLanguageOEMI(int_OEMId,"SMB",data.MN) }}</span>
                                        <span><i :class="data.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(data,checkModuleIndex(data.MN, data.MN, constAccessType.view),true,event,true)"></i></span>
                                    </div>
                                </a>
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="scroll" @mouseover="hover = true" @mouseleave="hover = false">
            <ul class="c-scroll-area c-sidebar-nav ps" style="position: relative;z-index: 5;">
                <template v-for="(menuTitle, index) in obj_menuTitle">
                    <li v-if="menuTitle.C == false && checkMenuAccess(menuTitle.MN) && menuTitle.HSM == false && menuTitle.IHM == false" class="c-sidebar-nav-dropdown" :class="[($parent.showSubMenu == menuTitle.MN && !isFirstLoad ? 'c-show' : ''),($parent.showActiveMenu.includes(menuTitle.PM)  || ($parent.showSubSubMenu && (menuTitle.PM == 'R' || menuTitle.PM == 'P' || menuTitle.PM == 'AGS' || menuTitle.PM == 'WEBS'|| menuTitle.PM == 'TOOLS' )) ? 'activeLvl1' : '')]">
                        <a class="c-sidebar-nav-dropdown-toggle" v-if="menuTitle.HSM == false && menuTitle.IHM == false" v-on:click="changeShowSubMenu(menuTitle.MN)">
                            <i :class="renderIcon(menuTitle.MN)"></i>
                            <!--<i class="fa fa-hand-holding-usd" v-else-if="menuTitle.MN =='D'"></i>
            <i class="fa fa-money-bill" v-else-if="menuTitle.MN =='W'"></i>
            <i class="fa fa-tag" v-else-if="menuTitle.MN =='P'"></i>-->
                            <div class="menu-Name">
                                <span>{{ menuTitle.MPI }}.</span>
                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                            </div>
                            <CBadge :style="renderPendingStyle(menuTitle.MN)" class="rounded-circle ml-auto" v-if="minimize==false" id="showNotification">{{ renderPendingNumber(menuTitle.MN) }}</CBadge>
                            <CBadge :style="renderPendingStyle(menuTitle.MN)" class="rounded-circle ml-auto" v-if="minimize==true" id="showNotificationMinimize">{{ renderPendingNumber(menuTitle.MN) }}</CBadge>
                        </a>
                        <ul class="c-sidebar-nav-dropdown-items">
                            <template v-for="(menuSubmenu, index) in obj_menuTitle">
                                <span v-if="menuSubmenu.C && menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == false && menuSubmenu.IHM == false">
                                <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.IHM == false && menuSubmenu.ISF != true && menuSubmenu.MN != 'VEC' && menuSubmenu.MN != 'VEB' && menuSubmenu.MN != 'VDH' && menuSubmenu.MN != 'CRMDU' && menuSubmenu.MN != 'LCHAT' && menuSubmenu.MN != 'UM'  && menuSubmenu.MN != 'VG' && menuSubmenu.MN != 'SAGTWL' && menuSubmenu.MN != 'STWO' && menuSubmenu.MN != 'VOTSB' " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN && ($parent.showSubSubMenu !='RS6')}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.MN) }}</span>
                                                <span><span v-if="!menuSubmenu.ESA && !menuSubmenu.EMA && !menuSubmenu.EAG" class="mandatory_Field">&nbsp;**</span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                <li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'SAGTWL' && menuSubmenu.IHM == false " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                <span v-if="getUserInfo.AT === 4">{{ getLanguage["SMB"]["NTWL"] }}</span>
                                                <span v-else>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                <!--li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'CRMDU'" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                    <a href="/auth/crm" id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                        <div class="dropdown-Name">
                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                            <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                            <span><span v-if="!menuSubmenu.ESA && !menuSubmenu.EMA && !menuSubmenu.EAG" class="mandatory_Field">&nbsp;**</span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                        </div>
                    </a>
                </li>-->
                                <li class="c-sidebar-nav-item" v-else-if="(menuTitle.MN == 'D' || menuTitle.MN == 'W' || menuTitle.MN == 'P') && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.add)" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.add) }}</span>
                                                <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                <!--<li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'LCHAT'" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                    <a href="/auth/LCHAT" id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                        <div class="dropdown-Name">
                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                            <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                            <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                        </div>
                    </a>
                </li>-->
                                <li class="c-sidebar-nav-item" v-else-if="((menuSubmenu.MN == 'VG') || (menuSubmenu.MN == 'UM')) && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.IHM == false" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN" target="_blank">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                </span>
                                <span v-if="menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == true && menuSubmenu.SMN.length > 0 && checkSubModuleAccess(menuSubmenu.SMN) && menuSubmenu.IHM == false">
                                <li class="c-sidebar-nav-item c-sidebar-nav-dropdown" v-if="checkMenuAccess(menuSubmenu.MN) && menuSubmenu.IHM == false" v-on:click="changeShowSubSubMenu(menuSubmenu.SMN)" :class="[(($parent.showSubSubMenu == menuSubmenu.SMN)  ? 'menuActive c-show' : ''),($parent.showSubSubMenu.includes(menuTitle.SPM) ? 'activeLvl2' : '')]" style="cursor:pointer">
                                    <div class="activeLvl2Div">
                                        <a id="subSubMenu" class="c-sidebar-nav-link c-sidebar-nav-dropdown-toggle haveSubMenu" target="_self">
                                            <div class="dropdown-Name">
                                                <span>{{ checkSubModuleIndex(menuSubmenu.MPI, menuSubmenu.PM, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.SMN) }}</span>
                                            </div>
                                        </a>
                                    </div>
                                </li>
                                <template v-for="(menuSubModulemenu, index) in obj_menuTitle">
                                    <span class="level3" v-if="menuSubModulemenu.C && menuSubModulemenu.SPM == menuSubmenu.SMN && menuSubModulemenu.HSM == true && menuSubModulemenu.IHM == false">
                                    <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view) && menuSubModulemenu.IHM == false" v-on:click="changeShowActiveMenu(menuSubModulemenu.PM + '.' + menuSubModulemenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubModulemenu.MN, 'd-block': $parent.showSubSubMenu == menuSubModulemenu.SPM, 'd-none': $parent.showSubSubMenu != menuSubModulemenu.SPM}" style="animation: fadeIn .5s; ">
                                        <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubModulemenu.MN">
                                            <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubModulemenu,checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI))">
                                                <div class="dropdown-Name dropdown-SubName">
                                                    <span>{{ checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                    <span v-if="menuSubModulemenu.MN == 'DR2'">{{ getLanguageOEMI(int_OEMId,"SMB","D") }}</span>
                                                    <span v-else-if="menuSubModulemenu.MN == 'WR2'">{{ getLanguageOEMI(int_OEMId,"SMB","W") }}</span>
                                                    <span v-else>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubModulemenu.MN) }}</span>
                                                    <span><i :class="menuSubModulemenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubModulemenu,checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI),true,event)"></i></span>
                                                </div>
                                            </a>
                                        </router-link>
                                    </li>
                                    </span>
                                </template>
                                </span>
                            </template>
                        </ul>
                    </li>

                    <!-- custom for promo rules only (simplify menu) -->
                    <li v-if="menuTitle.C == false && (menuTitle.MN == 'PRS' && menuTitle.PM == 'PRS') && menuTitle.HSM == false && menuTitle.IHM == false" :class="[($parent.showSubMenu == menuTitle.MN && !isFirstLoad ? 'c-sidebar-nav-dropdown c-show' : '')]">
                        <router-link :to="{ path:'/P/PRS', query:{ simplifymenu: 1 }}" class="c-sidebar-nav-dropdown-toggle after-none">
                            <i :class="renderIcon(menuTitle.MN)"></i>
                            <div class="menu-Name">
                                <span>{{ menuTitle.MPI }}.</span>
                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                            </div>
                        </router-link>
                    </li>
                </template>
            </ul>
        </div>

        <div class="d-flex justify-content-end">
            <span class="time-indicator d-sm-down-none">{{ DateTime | moment("DD MMM YYYY h:mm:ss a") }}</span>
            <!-- Button -->
            <CSidebarMinimizer class="d-sm-down-none" @click.native="changeMinimize" style="z-index:6" />
            <!-- End Button -->
        </div>

    </CSidebar>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../../modules/GenericHelper.js";
    import { constAccessType, constMenuIcon } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        name: 'SideMenuBar',
        props: ['isSimpleMode'],
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkMenuAccess', 'checkModuleAccess', 'checkModuleIndex', 'checkSubModuleAccess', 'checkSubModuleIndex']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion',
                'getPendingAutoDepositPlus'
            ]),
            ...mapGetters('SMBData', [
                'getCurrencySymbol',
                'getSystemBalance',
                'getCreditBalance',
                'getBalanceStatus',
                'getCurrencyCode'
            ]),
        },
        data() {
            return {
                minimize: false,
                isMinimize: false,
                hover: false,
                breakpoint: 'md',
                int_OEMId: 0,
                show: 'responsive',
                obj_menuTitle: {},
                favMenuList: [],
                //arry_cutmMN: ["AFF","AFFS","AFFL","AFFEL","DASH"],
                constAccessType: constAccessType,
                constMenuIcon: constMenuIcon,
                AutoUpdateTO: null,
                SystemBalance: null,
                CurrencySymbol: null,
                DateTime: this.getTodayDate(),
                timeout: [],
                isOUTMOB: '',
                isFirstLoad: true,
            }
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance',
                'setBalanceStatus',
                'setCurrencyCode'
            ]),
            ...mapActions('UserInfo', ['setMenuDisplayType']),
            changeMinimize() {
                this.isMinimize = !this.isMinimize;
                if (this.isMinimize) {
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else if (!this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
            },
            changeShowSubMenu(MN) {
                this.$route.matched[0].name = this.getLanguage["SMB"][MN];
                
                if (this.$parent.showSubMenu == MN && !this.isFirstLoad) {
                    this.$parent.showSubMenu = '';
                } else {                    
                    this.$parent.showSubMenu = MN;
                }
                this.isFirstLoad = false;
            },
            changeShowSubSubMenu(SMN) {
                if (this.$parent.showSubSubMenu == SMN) {
                    this.$parent.showSubSubMenu = '';
                } else {
                    this.$parent.showSubSubMenu = SMN;
                }                
            },
            changeShowActiveMenu(MN) {
                this.$parent.showActiveMenu = MN;                
                this.$notify({ clean: true, group: 'msgNotification' });

                if (this.$parent.showSubSubMenu == 'RS6' && this.$parent.showSubMenu != 'GS') {
                    this.$parent.showSubSubMenu = '';
                }

                if (!this.isOUTMOB) {
                    if (!this.$parent.showSubSubMenu) {
                        this.changeShowSubSubMenu('RS1')
                    }
                }                
                else {
                    this.changeShowSubSubMenu('RS3')
                }    


                //Game Settings collapse sub menu when click on other menu
                if (MN.split(".")[0] == "GS" && (
                    MN.split(".")[1] != "GPS" && MN.split(".")[1] != "M888S" &&
                    MN.split(".")[1] != "MV3S" && MN.split(".")[1] != "P888S" &&
                    MN.split(".")[1] != "K918S" && MN.split(".")[1] != "A288S" &&
                    MN.split(".")[1] != "AFBCS" && MN.split(".")[1] != "LG88S" &&
                    MN.split(".")[1] != "GD88S" && MN.split(".")[1] != "IGS" &&
                    MN.split(".")[1] != "NKS" && MN.split(".")[1] != "W9S"
                )) {
                    if (!this.isOUTMOB) {
                        this.changeShowSubSubMenu('RS1');
                    }
                    else {
                        this.changeShowSubSubMenu('RS3');
                    }
                } 
                

                // when click report will auto minimize sidemenu
                if (MN.split(".")[0] == "R") {
                    this.isMinimize = true;
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else {
                    this.isMinimize = false;
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
            },
            getFromSystemBalance() {
                var that = this;

                if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {
                    this.getDataApi(`/api/ag/gcag`,
                        function (d, s) {
                            if (s) {
                                that.setCurrencySymbol(d.D.CS);
                                that.setSystemBalance(d.D.SB);
                                that.setCreditBalance(d.D.CB2);
                                that.setBalanceStatus(d.D.BS);
                                that.setCurrencyCode(d.D.ISOC);

                                //Store in localstorage for remaining tabs
                                localStorage.setItem('CS', d.D.CS);
                                localStorage.setItem('SB', d.D.SB);
                                localStorage.setItem('CB', d.D.CB2);
                                localStorage.setItem('BS', d.D.BS);
                                localStorage.setItem('ISOC', d.D.ISOC);
                            }
                        });
                }
                else {                    
                    that.setCurrencySymbol(localStorage.getItem('CS'));
                    that.setSystemBalance(localStorage.getItem('SB'));
                    that.setCreditBalance(localStorage.getItem('CB'));
                    that.setBalanceStatus(localStorage.getItem('BS'));
                    that.setCurrencyCode(localStorage.getItem('ISOC'));
                }                
            },
            getmenuTitle(isSimpleMode) {
                var that = this;
                //this.getDataApi(`/api/role/g/0`,
                this.getDataApi(`/api/role/gv/0/0/` + isSimpleMode,
                    function (d, s) {
                        if (s) {
                            that.setmenuTitle(d);
                        }
                    });
            },
            setmenuTitle(data) {
                this.obj_menuTitle = data.RoleAccessList;
                if (data.FavMenuList != null && data.FavMenuList.length > 0) {
                    var favMenuCount = 0;
                    this.favMenuList = [];
                    for (var i = 0; i < data.FavMenuList.length; i++) {
                        if (favMenuCount == 5)
                            break;
                        else if (this.checkModuleAccess(data.FavMenuList[i].MN, data.FavMenuList[i].PM, this.constAccessType.view)) {
                            this.favMenuList.push(data.FavMenuList[i]);
                            favMenuCount++;
                        }
                    }
                }
                //this.favMenuList = data.FavMenuList;
                if (this.isOUTMOB) {
                    var that = this;
                    var tempMenu = []; // temperory hide menu in outlet mobile
                    $.each(that.obj_menuTitle, function (index, elem) {
                        if (elem.PM == "DASH" || elem.PM == "P" || (elem.PM == "R" && elem.SMN == "RS2") || (elem.PM == "R" && elem.MN == "WINLV2") || (elem.PM == "R" && elem.MN == "SAGTWL") || (elem.PM == "R" && elem.SMN == "RS4") || elem.PM == "AFF" || elem.PM == "MS" || elem.PM == "L" || elem.PM == "D" || elem.PM == "W" || (elem.PM == "M" && elem.MN == "BLL") || (elem.PM == "GS" && elem.MN == "GSDU") || (elem.PM == "AGS" && elem.MN == "SUBHRY") ||elem.ISF == true) {
                        } else {
                            tempMenu.push(elem)
                        }                        
                    });
                    that.obj_menuTitle = tempMenu;          
                }

                if (this.$route.path == "/") {
                    var ParentModule = "";
                    var ModuleName = "";
                    for (var i = 0; i < this.obj_menuTitle.length; i++) {
                        if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB') {
                            var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                            ParentModule = this.obj_menuTitle[i].PM;
                            ModuleName = this.obj_menuTitle[i].MN;
                            this.$router.push(link);
                            break;
                        }
                    }
                    this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                } else {
                    var temp = this.$parent.showActiveMenu.split('.');
                    var ParentModule = "";
                    var ModuleName = "";
                    if (temp.length > 0) {
                        ParentModule = temp[0];
                        ModuleName = temp[1];
                    }
                    this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                }

                for (var i = 0; i < this.obj_menuTitle.length; i++) {                    
                    if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB'&& this.obj_menuTitle[i].ISF ==false ) {
                        var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                        this.$parent.FisrtMenuItem = link;
                        break;
                    }
                }
                this.$parent.bool_fullpageLoading = false;
            },
            renderIcon(menuTitle) {
                return this.constMenuIcon[menuTitle];
            },
            renderPendingStyle(menuTitle) {
                if (menuTitle == 'D' && this.getPendingDeposit > 99) {
                    return { 'background-color': '#30878e', 'font-size': '8.5px' };
                } else if (menuTitle == 'W' && this.getPendingWithdrawal > 99) {
                    return { 'background-color': '#e53636', 'font-size': '8.5px' };
                } else if (menuTitle == 'P' && this.getPendingPromotion > 99) {
                    return { 'background-color': '#6f6bd6', 'font-size': '8.5px' };
                } else if (menuTitle == 'D') {
                    return { 'background-color': '#30878e' };
                } else if (menuTitle == 'W' || (menuTitle == 'B' && this.getPendingAutoDepositPlus > 0)) {
                    return { 'background-color': '#e53636' };
                } else if (menuTitle == 'P') {
                    return { 'background-color': '#6f6bd6' };
                }
            },
            renderPendingNumber(menuTitle) {
                if (menuTitle == 'D') {
                    return (this.getPendingDeposit <= 99) ? this.getPendingDeposit : '99+';
                } else if (menuTitle == 'W') {
                    return (this.getPendingWithdrawal <= 99) ? this.getPendingWithdrawal : '99+';
                } else if (menuTitle == 'P') {
                    return (this.getPendingPromotion <= 99) ? this.getPendingPromotion : '99+';
                } else if (menuTitle == 'B' && this.getPendingAutoDepositPlus > 0) {
                    return (this.getPendingAutoDepositPlus <= 99) ? this.getPendingAutoDepositPlus : '99+';
                }
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getFromSystemBalance();
            },
            getDate() {
                var self = this;
                self.DateTime = new Date();
                self.timeout[0] = setTimeout(() => {
                    self.getDate();
                }, 1000);
            },
            copyReferralLink: function () {
                var inp = document.createElement('input');
                document.body.appendChild(inp)
                inp.value = this.getUserInfo.SARL;
                inp.select();
                document.execCommand('copy', false);
                inp.remove();

                Vue.notify({
                    group: 'msgNotificationTop',
                    type: 'success',
                    // title: 'Title',
                    text: this.getLanguage['GL']['CPSC'],
                    duration: 2000
                });
            },
            onHandleWindowResize() {
                var $win = $(window);
                this.windowWidth = $win.width();
                this.windowHeight = $win.height();

                if (this.windowWidth >= 768 && !this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                } else if (this.windowWidth < 768) {
                    this.minimize = false;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else {
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                }
            },
            redirectToCreditHistory() {
                if (this.getUserInfo.AT === 4) {
                    this.$router.push("/AGS/SubAgentCreditHistory?agi=4-" + this.getUserInfo.AGI + '&iol=' + (this.getUserInfo.IOL ? '1' : '0'));
                }
            },
            addMenuToFavorite(Menu, MenuIndexDisplay, checkFavorite = false, event = null, ClickdFromFav = false) {
                if (event) {
                    event.preventDefault();
                }
                if (checkFavorite) {
                    Menu.IFM = !Menu.IFM;
                }
                this.isFirstLoad = ClickdFromFav;
                if (ClickdFromFav) {
                    const temp = this.obj_menuTitle.find(f => { return f.PM == Menu.PM && f.MN == Menu.MN });
                    if (temp) {
                        temp.IFM = Menu.IFM;
                    }
                } else {
                    const temp = this.favMenuList.find(f => { return f.PM == Menu.PM && f.MN == Menu.MN });
                    if (temp) {
                        temp.IFM = Menu.IFM;
                    }
                }
                var that = this;
                this.postDataApi(`/api/role/add-fav`, { 'PM': Menu.PM, 'MN': Menu.MN, 'IFM': Menu.IFM, 'FAVBTN': checkFavorite, 'MID': MenuIndexDisplay },
                    function (d, s) {
                        if (d && !d.S) {
                            Menu.IFM = !Menu.IFM;
                            that.showErrorMessage(null, that.getLanguage["FAV"]["MAXMENU"]);
                        }
                    });
            }
        },
        watch: {
            hover() {
                if (this.isMinimize) {
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else if (!this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
                if (this.hover && this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
            },
            isSimpleMode() {
                this.obj_menuTitle = {};
                this.favMenuList = [];
                this.$parent.bool_fullpageLoading = true;
                if (this.isSimpleMode) {
                    localStorage.setItem('isSimpleMode', 'True');
                    this.setMenuDisplayType(1)
                    this.getmenuTitle(1);
                } else {
                    localStorage.setItem('isSimpleMode', 'False');
                    this.setMenuDisplayType(0)
                    this.getmenuTitle(0);
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            next();
        },
        mounted() {
            this.onHandleWindowResize();
            window.addEventListener("resize", this.onHandleWindowResize);
            this.int_OEMId = this.getUserInfo.OEMI;
            this.$root.$on('toggle-sidebar', () => {
                const sidebarOpened = this.show === true || this.show === 'responsive'
                this.show = sidebarOpened ? false : 'responsive'
            })
            this.$root.$on('toggle-sidebar-mobile', () => {
                const sidebarClosed = this.show === 'responsive' || this.show === false
                this.show = sidebarClosed ? true : 'responsive'
            })

            if (localStorage.getItem('isOutletMobile') === null) {
                if (this.getUserInfo.IOL && this.getUserInfo.IMD) {
                    localStorage.setItem('isOutletMobile', 'True');
                    document.getElementById('changeView').className = "view-desktop";
                } else {
                    localStorage.setItem('isOutletMobile', 'False');
                    document.getElementById('changeView').className = "view-mobile";
                }
            } else if (localStorage.getItem('isOutletMobile') == 'True' && this.getUserInfo.IOL && this.getUserInfo.IMD) {
                localStorage.setItem('isOutletMobile', 'True');
                document.getElementById('changeView').className = "view-desktop";
            } else {
                localStorage.setItem('isOutletMobile', 'False');
                document.getElementById('changeView').className = "view-mobile";
            }
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true : false;

            this.getFromSystemBalance();
            if (localStorage.getItem('isSimpleMode') === 'False') {
                this.$parent.isSimpleMode = false;
                this.setMenuDisplayType(0)
                this.getmenuTitle(0);
            } else {
                this.$parent.isSimpleMode = true;
                this.setMenuDisplayType(1)
                this.getmenuTitle(1);
            }
            this.AutoUpdate();
            this.getDate();
            this.changeShowActiveMenu(this.$parent.showActiveMenu);

        },
    }
</script>

<style>
    .blobs-container {
        display: flex;
    }

    .blob {
        background: transparent;
        border-radius: 50%;
        box-shadow: 0 0 0 0 rgba(169, 173, 204, 1);
        margin-right: 15px;
        margin-left: 4px;
        height: 20px;
        width: 20px;
        transform: scale(1);
        animation: pulse-ssa 3s infinite;
    }
    .blob:hover {
        animation: pulse-ssa 3s infinite;
    }
    @keyframes pulse-ssa {
        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(169, 173, 204, 0.7);
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 5px rgba(169, 173, 204, 0);
        }

        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(169, 173, 204, 0);
        }
    }
    .freeze-user {
        background: #8ce1f6;
        color: #0c1033 !important;
        font-weight: 600;
        padding: 0.25rem 0rem 0.25rem .5rem;
        border-radius: 5px;
    }
    .cil-snowflake.freeze {
        padding: .25rem .0rem;
        margin-right: 0 !important;
        font-size: 13px;
        color: #0c1033 !important;
        width: 20px !important;
        height: 15px !important;
        align-items: unset !important;
        display: flex;
    }

</style>



// WEBPACK FOOTER //
// src/components/SideMenu/SideMenuBar.vue